module.exports = __webpack_public_path__ + "static/media/IMG_20200613_192136.4dd35583.webp";